// extracted by mini-css-extract-plugin
module.exports = {"my_profile_welcome_card":"ProfileWelcomeCard_my_profile_welcome_card__2RrUL","card_footer":"ProfileWelcomeCard_card_footer__1BJt_"};